import React, { ReactNode, useEffect, FC } from 'react';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import Honeybadger from '@honeybadger-io/js';
import { ReduxState } from 'kb-shared';

import StripeWrapper from './StripeWrapper';

const PATIENT_STRIPE_KEY = gql`
  query patientStripeKey {
    patient {
      id
      lab {
        id
        stripePublicKey
      }
    }
  }
`;

type PatientLab = {
  patient: {
    id: string;
    lab: {
      id: string;
      stripePublicKey: string;
    };
  };
};

type Props = {
  isLoggedIn?: boolean;
  isConfirmed?: boolean;
  children: ReactNode;
};

const PatientStripeProvider: FC<Props> = (props: Props) => {
  const { isLoggedIn, isConfirmed, children } = props;
  const { error, data } = useQuery<PatientLab>(PATIENT_STRIPE_KEY, {
    skip: isLoggedIn === false
  });

  const stripeKey = data?.patient?.lab?.stripePublicKey ?? undefined;

  useEffect(() => {
    if (error) {
      console.error(error);
      Honeybadger.notify('StripeTokenError', error);
    }
  }, [error]);

  return <StripeWrapper stripeKey={stripeKey}>{children}</StripeWrapper>;
};

const mapStateToProps = ({ patient }: ReduxState) => ({
  isLoggedIn: patient.isLoggedIn,
  isConfirmed: patient.patient.confirmed
});

export default connect(mapStateToProps, null)(PatientStripeProvider);
